import { ChatbotDashboardTabField } from './chatbot-dashboard-tab-field.component'
import { ChatbotShowUnreachedField } from './chatbot-show-unreached-field.component'
import { ChatbotSmsDeliveryField } from './chatbot-sms-delivery-field.component'

export function ChatbotDashboardSection() {
  return (
    <div className="c-flex c-flex-col c-gap-4 c-rounded-lg c-border c-border-gray-400 c-p-4">
      <ChatbotDashboardTabField />
      <div className="c-flex c-flex-col c-gap-4 [&>div>div]:c-w-max">
        <ChatbotShowUnreachedField />
        <ChatbotSmsDeliveryField />
      </div>
    </div>
  )
}
